/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
import Modal from "../../../../components/common/Modal/Modal";
import Typography from "../../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus, TEXTFIELD } from "../../../../contants";
import Appointment from "../../../../services/api/appointment";
import LabelInputField from "../components/LabellnputField/LabelInputField";
import styles from "./BulkTransfer.styles";

const customStyle = {
  minWidth: "240px",
};

function EditStructureModal({
  open,
  onClose,
  hierarchy,
  structureId,
  refreshList,
}) {
  const [structureName, setStructureName] = useState("");
  const alert = useContext(ToastAlertContext);

  const onBack = () => onClose();

  const onSubmit = async () => {
    try {
      if (!structureName.length) throw new Error("Please enter a valid name");

      await Appointment.updateSplitStructure({
        parentId: structureId,
        data: { name: structureName, hierarchy },
      });
      alert.show("Updated Successfully", AlertStatus.SUCCESS);
      refreshList();
      onBack();
    } catch (error) {
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose} customStyle={customStyle}>
      <Box>
        <Typography variant="title3" color="#8c8c8c" caseing="capitalize">
          Edit Details
        </Typography>
        <Grid item xs={12}>
          <Grid container columnSpacing={8}>
            <Grid item xs={12}>
              <LabelInputField
                required
                sideLabel="Add Name"
                type={TEXTFIELD}
                value={structureName}
                label="Enter new  Name"
                onChange={(e) => setStructureName(e.target.value)}
              />
            </Grid>
          </Grid>
          <Box style={styles.btn}>
            <Button label="Update" onClick={onSubmit} />
            <Button label="Cancel" onClick={onBack} variant="outlined" />
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
}

export default EditStructureModal;
